<template>
  <div class="HStack flex" v-bind="$attrs">
    <div
      class="flex flex-row w-full h-full"
      :class="[...classes, margin && '-w-m']"
      :style="createStyle({ '--child-margin': margin })"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMargin, type StackingProps, useStackingClasses } from './utils'
import { createStyle } from '/@/utils/misc'

export default defineComponent({
  props: {
    spacing: [String, Number],
    fill: Boolean,
    align: String,
  },
  setup(props) {
    const margin = useMargin(props as StackingProps)
    const classes = useStackingClasses(props as StackingProps)

    return {
      createStyle,
      margin,
      classes,
    }
  },
})
</script>

<style lang="scss">
.HStack {
  height: inherit;

  &.-fill {
    flex: 1;
  }

  > div {
    flex: inherit;
    --child-margin: 0;

    &.-w-m {
      > * + * {
        margin-left: var(--child-margin);
      }
    }
  }
}
</style>
